import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-381e0775"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_guess_component = _resolveComponent("guess-component")!
  const _component_guess_count = _resolveComponent("guess-count")!
  const _component_word_component = _resolveComponent("word-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_guess_component, {
          letters: _ctx.squareController.guessData.letters
        }, null, 8, ["letters"]),
        _createVNode(_component_guess_count, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onGuessCountPressed'))),
          count: _ctx.squareController.guesses.length
        }, null, 8, ["count"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.squareController.words, (word, index) => {
        return (_openBlock(), _createBlock(_component_word_component, {
          rowIndex: index,
          wordData: word,
          lettersScale: _ctx.squareController.lettersScale[index],
          showCorrectAnswer: _ctx.squareController.isFinished,
          key: `word-${index}`
        }, null, 8, ["rowIndex", "wordData", "lettersScale", "showCorrectAnswer"]))
      }), 128))
    ])
  ]))
}